import { Component, OnInit, Input } from '@angular/core';
import { MilestoneService } from 'src/app/services/milestone.service';
import { Milestone } from 'src/app/model/milestone';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { trigger } from '@angular/animations';
import { state } from '@angular/animations';
import { style } from '@angular/animations';
import { transition } from '@angular/animations';
import { animate } from '@angular/animations';

@Component({
  selector: 'milestone',
  templateUrl: 'milestone.html',
  styleUrls: ["milestone.css"],
  animations: [
    trigger('selectedPosition', [
      state('selected', style({
        marginRight: "1.5rem",
        transform: "translateX(1.5rem)"
      })),
      state('not-selected', style({
        marginRight: "0",
        transform: "translateX(0)"
      })),
      transition('not-selected => selected', animate("200ms")),
      transition('selected => not-selected', animate("200ms"))
    ]),
    trigger('selectedColor', [
      state('selected', style({
        borderColor: "#D9D9D9"
      })),
      state('not-selected', style({
        borderColor: "transparent"
      })),
      transition('not-selected => selected', animate("300ms"))
    ]),
    trigger('selectedText', [
      state('selected', style({
        color: "#000000"
      })),
      state('not-selected', style({
        color: "transparent"
      })),
      transition('not-selected => selected', animate("300ms 200ms"))
    ])
  ]
})

export class MilestoneComponent {
  @Input() milestone: Milestone;
  @Input() isSelected: string = "selected";
  @Output() selected = new EventEmitter<Milestone>();

  constructor() { }

  private select(): void {
    this.selected.emit(this.milestone);
  }
}
